import { Component, OnInit, Input } from '@angular/core';
import { DataManagementService } from '../../data-management/data-management.service';
import { ModalController, Platform, PopoverController } from '@ionic/angular';
import { Vehicule } from 'src/app/model/data-managemnt';
import { SigninService } from 'src/app/signin/signin.service';

//let HighchartsMore = require('highcharts/highcharts-more');
//let HighchartsSolidGauge = require('highcharts/modules/solid-gauge');

//HighchartsMore(Highcharts);
//HighchartsSolidGauge(Highcharts)

@Component({
  selector: 'app-dashborad',
  templateUrl: './dashborad.component.html',
  styleUrls: ['./dashborad.component.scss'],
})
export class DashboradComponent implements OnInit {

  charged: boolean = false;

  //selectedV: any;
  marque: string;
  matricule: string;

  fuelLitreValue: number;
  tow: number;
  dateTow: string;
  backButtonSubscription: any;
  constructor(public dataManagementService: DataManagementService, public modalController: ModalController, private platform: Platform,
    private popoverCtrl: PopoverController, public signinService: SigninService
  ) {
    this.marque = this.dataManagementService.selectedVehicule!.mark;
    this.matricule = this.dataManagementService.selectedVehicule!.matricule;
  }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.backButtonSubscription = this.platform.backButton.subscribe(async () => {
      navigator['app'].exitApp();
    });
  }
  ionViewDidLeave() {
    this.backButtonSubscription.unsubscribe();
  }

  async close() {
    await this.popoverCtrl.dismiss('cancel');
  }

  calculateFuelPercent(fuel: number | undefined, min: number | undefined, max: number | undefined): number {
    if (fuel === undefined || min === undefined || max === undefined) return 0;

    if (max - min > 0) {
      if (fuel >= min && fuel <= max) {
        return Math.round(((fuel - min) / (max - min)) * 100);
      }
    } else {
      if (fuel >= max && fuel <= min) {
        return Math.round(((fuel - min) / (max - min)) * 100);
      }
    }
    return 0;
  }
}
